import { assertEvent, assign } from 'xstate5';

import { type BundleMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Records the product highlighted in the selection modal, before it is
 * confirmed into the bundle.
 */
export const storePendingProduct: BundleMachineAction = assign((args) => {
  const { event } = args;

  assertEvent(event, 'SELECT');

  return {
    pendingProduct: { productSlug: event.productSlug, restaurantSlug: event.restaurantSlug },
  };
});
